module.exports = __webpack_public_path__ + "static/3_2_bayes-rule-1-3d5328b2a006cca62ed8c54f47be33b1.svg";